export default __webpack_public_path__ + "38e3c6b85f374c46d0ed71baec3ed1c1.svg";